import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { RequestTypes } from '../requestTypes'
import { planPermitsKeys } from '../planPermitsKeys'
import {
  IProjectPlanPermits,
  ProjectPlanPermits,
} from '@core/entities/project/ProjectPlanPermits'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const planPermitsTransform = (data) => ProjectPlanPermits.new(data)

export const useGetPlanPermits = (
  payload: RequestTypes['getPlanPermits'],
  options?: UseQueryOptions<
    IProjectPlanPermits,
    RequestErrorType,
    ProjectPlanPermits
  >,
) => {
  return useQuery({
    select: planPermitsTransform,
    ...planPermitsKeys.getPlanPermits(payload),
    ...options,
  })
}
